import { TextField } from '@bingads-webui-react/fabric-with-signal';
import { Select as ValidatedSelect } from '@bingads-webui-react/primitive-validation';

import {
  withValidation,
  withServerError,
} from '@bingads-webui-react/validation';
import { withError } from './with-error';

export const ValidatedInput = withError(withValidation(TextField));
export const Input = withServerError(ValidatedInput);

export const Select = withServerError(ValidatedSelect);
